// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarSchedule_UyZDg {
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow-x: scroll;
	.days_Hn0Hu {
		width: 100%;
		display: flex;
		overflow-x: scroll;
	}
	.dayColumn_q56br {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 0px 8px;
	}
	.hour_pkKkn {
		border: 1px solid var(--border-color);
		color: var(--_10a37f-background);
		padding: 10px 5px;
		margin: 2px;
		width: 80px;
		text-align: center;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
		border-radius: 4px;
		&:hover {
			font-weight: 600;
			background: var(--_16c0982e-background);
			border: 1px solid var(--_10a37f-background);
		}
	}
	.dayHeader_IizkS {
		font-weight: bold;
		margin-bottom: 10px;
	}
}
.occupiedHour_hH1_V {
	border: 1px solid var(--e6fff9-background);
	color: var(--white-color);
	padding: 10px 5px;
	background: var(--e6fff9-background);
	margin: 2px;
	width: 80px;
	text-align: center;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	border-radius: 4px;
	transition: all 0.2s ease;
	&:hover {
		font-weight: 600;
		background: var(--_16c098-background);
		border: 1px solid var(--_16c098-background);
	}
}
.disabledHour_EJ255 {
	background-color: var(--f5-background);
	cursor: not-allowed !important;
	color: var(--text-color-secondary);
	padding: 10px 5px;
	margin: 2px;
	width: 80px;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
	border-radius: 4px;
	opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/WatchCalendar/CustomCalendar/CustomCalendar.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB;EACC,WAAW;EACX,aAAa;EACb,kBAAkB;CACnB;CACA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;CAChB;CACA;EACC,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB;GACC,gBAAgB;GAChB,uCAAuC;GACvC,2CAA2C;EAC5C;CACD;CACA;EACC,iBAAiB;EACjB,mBAAmB;CACpB;AACD;AACA;CACC,0CAA0C;CAC1C,yBAAyB;CACzB,iBAAiB;CACjB,oCAAoC;CACpC,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB;EACC,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;CAC5C;AACD;AACA;CACC,sCAAsC;CACtC,8BAA8B;CAC9B,kCAAkC;CAClC,iBAAiB;CACjB,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;AACb","sourcesContent":[".calendarSchedule {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow-x: scroll;\n\t.days {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\toverflow-x: scroll;\n\t}\n\t.dayColumn {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tmargin: 0px 8px;\n\t}\n\t.hour {\n\t\tborder: 1px solid var(--border-color);\n\t\tcolor: var(--_10a37f-background);\n\t\tpadding: 10px 5px;\n\t\tmargin: 2px;\n\t\twidth: 80px;\n\t\ttext-align: center;\n\t\tcursor: pointer;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tborder-radius: 4px;\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t\tbackground: var(--_16c0982e-background);\n\t\t\tborder: 1px solid var(--_10a37f-background);\n\t\t}\n\t}\n\t.dayHeader {\n\t\tfont-weight: bold;\n\t\tmargin-bottom: 10px;\n\t}\n}\n.occupiedHour {\n\tborder: 1px solid var(--e6fff9-background);\n\tcolor: var(--white-color);\n\tpadding: 10px 5px;\n\tbackground: var(--e6fff9-background);\n\tmargin: 2px;\n\twidth: 80px;\n\ttext-align: center;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tborder-radius: 4px;\n\ttransition: all 0.2s ease;\n\t&:hover {\n\t\tfont-weight: 600;\n\t\tbackground: var(--_16c098-background);\n\t\tborder: 1px solid var(--_16c098-background);\n\t}\n}\n.disabledHour {\n\tbackground-color: var(--f5-background);\n\tcursor: not-allowed !important;\n\tcolor: var(--text-color-secondary);\n\tpadding: 10px 5px;\n\tmargin: 2px;\n\twidth: 80px;\n\ttext-align: center;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tborder-radius: 4px;\n\topacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarSchedule": `calendarSchedule_UyZDg`,
	"days": `days_Hn0Hu`,
	"dayColumn": `dayColumn_q56br`,
	"hour": `hour_pkKkn`,
	"dayHeader": `dayHeader_IizkS`,
	"occupiedHour": `occupiedHour_hH1_V`,
	"disabledHour": `disabledHour_EJ255`
};
export default ___CSS_LOADER_EXPORT___;
